<div
  class="delete-ssp-source"
  [style.min-height]="data.sourceSSPDataLength > 0 ? '460px' : '300px'"
>
  <div class="delete-ssp-source__header">
    <h2 id="deactivationWarningTitle" class="delete-ssp-source__title">
      Are you sure you want to delete Source Schain?
    </h2>
    <div class="delete-ssp-source__close">
      <span
        nz-icon
        nzType="close"
        nzTheme="outline"
        (click)="onCloseModal()"
      ></span>
    </div>
  </div>

  <div class="delete-ssp-source__body">
    <p class="delete-ssp-source__lead">Deletion will:</p>
    <ul class="delete-ssp-source__list">
      <li class="delete-ssp-source__item">
        Permanently
        <span class="bold">delete</span>
        this Source Schain file
      </li>
      <li class="delete-ssp-source__item" *ngIf="data.sourceSSPDataLength > 0">
        Keep the <span class="bold">SSP Source Schain</span> checkbox
        <span class="bold">active</span> on any DSP endpoints where it is
        enabled.
      </li>
      <li
        class="delete-ssp-source__item"
        *ngIf="data.sourceSSPDataLength === 0"
      >
        <span class="bold">Deactivate</span> SSP Source Schain checkbox on any
        DSP endpoints where it was enabled.
      </li>
    </ul>

    <p class="delete-ssp-source__notice" *ngIf="data.sourceSSPDataLength > 0">
      Before deleting, please review your endpoint settings. If this file is
      linked to active DSP endpoints, make sure to update your
      <span class="bold">direct SSP/DSP allow lists</span> and applied
      <span class="bold">Filter lists</span>, otherwise those endpoints may
      continue running with incomplete Source Schain settings.
    </p>
  </div>

  <div class="delete-ssp-source__footer">
    <button
      nz-button
      type="button"
      nzType="default"
      class="delete-ssp-source__btn delete-ssp-source__btn--secondary"
      (click)="onCloseModal()"
    >
      Go Back
    </button>
    <button
      nz-button
      type="button"
      nzType="primary"
      class="delete-ssp-source__btn delete-ssp-source__btn--primary"
      (click)="onConfirm()"
    >
      Confirm
    </button>
  </div>
</div>
